import { computed } from 'vue'

import api from '@/store/api'
import { mapTypeIncludingInactive } from '@/store/mappers'
import { pickCateringAgent } from '@/view/ai/agentTypes'

export function useCateringAgent() {
  const agent = computed(() => pickCateringAgent(mapTypeIncludingInactive('agent')))
  const load = () => api.call('GET', 'agents?included=agent_playbook').then(() => agent.value)
  return { agent, load }
}
